import { ActionIcon, Center, Flex, Text, Tooltip } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { HiOutlineArrowDown, HiOutlineArrowUp } from 'react-icons/hi';
import { raterDataType } from '../../../views/rater_form_detail';

interface SequenceActionProps {
  data: any;
  rawData: any;
  index: number;
  itemNumber: number;
  handleChangeSequence: (data: any, type: 'down' | 'up') => void;
}

const SequenceAction: React.FC<SequenceActionProps> = ({
  rawData,
  data,
  index,
  itemNumber,
  handleChangeSequence
}) => {
  const [groupedDataType, setGroupedDataType] = useState(null);

  if (rawData && rawData.length === 1) return null;

  useEffect(() => {
    if (rawData && rawData.length > 0) {
      const grouped = rawData.reduce((acc, item) => {
        const key = item.jenis;
        if (raterDataType.includes(key)) {
          acc[key].push(item);
        }
        return acc;
      }, Object.fromEntries(raterDataType.map((jenis) => [jenis, []])));

      setGroupedDataType(grouped);
    }
  }, [rawData]);

  if (groupedDataType && groupedDataType[data[index].jenis].length === 1)
    return (
      <Center>
        <Text size="xs">1</Text>
      </Center>
    );

  return (
    <Flex justify={'center'} gap={4} align={'center'} flex={1}>
      {groupedDataType &&
        data[index].raterID ===
          groupedDataType[data[index].jenis][0].raterID && (
          <Tooltip label="Go Down Position">
            <ActionIcon
              variant="transparent"
              size="sm"
              onClick={() => handleChangeSequence(data[index], 'down')}
            >
              <Flex direction={'column'}>
                <HiOutlineArrowDown size={16} />
                <Text size="xs">({data[index].nomor})</Text>
              </Flex>
            </ActionIcon>
          </Tooltip>
        )}

      {groupedDataType &&
        data[index].raterID ===
          groupedDataType[data[index].jenis][
            groupedDataType[data[index].jenis].length - 1
          ].raterID && (
          <Tooltip label="Go Up Position">
            <ActionIcon
              variant="transparent"
              size="sm"
              onClick={() => handleChangeSequence(data[index], 'up')}
            >
              <Flex direction={'column'}>
                <HiOutlineArrowUp size={16} />
                <Text c="dark" size="xs">
                  ({data[index].nomor})
                </Text>
              </Flex>
            </ActionIcon>
          </Tooltip>
        )}

      {groupedDataType &&
        data[index].raterID !== groupedDataType[data[index].jenis][0].raterID &&
        data[index].raterID !==
          groupedDataType[data[index].jenis][
            groupedDataType[data[index].jenis].length - 1
          ].raterID && (
          <Flex direction={'column'} align={'center'} justify={'center'}>
            <Flex>
              <Tooltip label="Go Down Position">
                <ActionIcon
                  variant="transparent"
                  size="sm"
                  onClick={() => handleChangeSequence(data[index], 'down')}
                >
                  <HiOutlineArrowDown size={16} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Go Up Position">
                <ActionIcon
                  variant="transparent"
                  size="sm"
                  onClick={() => handleChangeSequence(data[index], 'up')}
                >
                  <HiOutlineArrowUp size={16} />
                </ActionIcon>
              </Tooltip>
            </Flex>
            <Text size="xs">({data[index].nomor})</Text>
          </Flex>
        )}
    </Flex>
  );
};

export default SequenceAction;
